import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { createshoppingListItem } from 'src/app/core/model/api-response/cooking-story-model';
import { FoodUnitRatioModel } from 'src/app/core/model/object/diet-food-model';
import {
  RecipeIngredientModel,
  RecipeIngredientUnitModel,
} from 'src/app/core/model/object/recipe-model';
import { CookingStoryGroceryApiService } from './cooking-story-kitchen-api.service';

@Injectable({
  providedIn: 'root',
})
export class CookingStoryRecipePageDataService {
  private ingredients: Map<string, RecipeIngredientModel> = new Map();
  private saveingredients: Map<string, RecipeIngredientModel> = new Map();

  private currentEditItem: string;
  constructor(
    private cookingStoryGroceryApiService: CookingStoryGroceryApiService
  ) {}
  clearList() {
    this.ingredients.clear();
    this.saveingredients.clear();
    this.currentEditItem = null;
  }

  addItems(items: RecipeIngredientModel[]) {
    items.map((data) => {
      this.saveingredients.set(data._id, data);
    });
  }
  getBackupSaves() {
    const data = Array.from(this.saveingredients, ([key, value]) => value);
    return data;
  }
  getBackUpItem(id: string): RecipeIngredientModel {
    return this.saveingredients.get(id);
  }
  addItem(edittedItem: RecipeIngredientModel) {
    const item = this.getItem(edittedItem._id);
    if (!item) {
      this.ingredients.set(edittedItem._id, edittedItem);
    } else {
      this.ingredients.delete(edittedItem._id);
    }
  }
  justAddItem(edittedItem: RecipeIngredientModel) {
    this.ingredients.set(edittedItem._id, edittedItem);
  }
  deleteItem(id: string) {
    this.ingredients.delete(id);
  }
  changeActiveItemId(id: string): void {
    this.currentEditItem = id;
  }
  getActiveItemId(): string {
    return this.currentEditItem;
  }
  getItems() {
    const data = Array.from(this.ingredients, ([key, value]) => value);
    return data;
  }

  getItem(id: string): RecipeIngredientModel {
    return this.ingredients.get(id);
  }
  getItemsSize(): number {
    return this.saveingredients.size;
  }
  changeUnit(id: string, unit: RecipeIngredientUnitModel) {
    const data = this.getItem(id);
    if (data) {
      data.unit = unit;
      this.ingredients.set(id, data);
    }
  }
  changeSaveUnit(id: string, unit: string) {
    const data = this.getBackUpItem(id);
    if (data) {
      const item = new RecipeIngredientModel(
        data.amount,
        data.cooked,
        data.food,
        null,
        data._id,
        unit,
        data.description,
        data.kitchenInventory,
        data.mainUnit
      );
      this.saveingredients.set(id, item);
    }
  }
  updateItem(newItem: RecipeIngredientModel) {
    this.ingredients.set(newItem._id, newItem);
  }
  updateSaveItem(edittedItem: RecipeIngredientModel) {
    this.saveingredients.set(edittedItem._id, edittedItem);
  }
  saveCart(ids: string[]) {
    const items = this.getItems();
    const saved = items.map((data) => {
      const createdItem = new createshoppingListItem(
        data.food._id,
        data.amount,
        null,
        data.unitDescription,
        data.description,
        null
      );
      delete createdItem.quickAdd;
      return createdItem;
    });
    this.cookingStoryGroceryApiService
      .saveShoppingListItems(saved)
      .then(() => this.clearList());
  }
}
